module.exports = __webpack_public_path__ + "static/media/cozy9168.e5b1ca6f.jpg";